var map = {
	"./about.md": [
		3428,
		428
	],
	"./cap-roundup.md": [
		9181,
		181
	],
	"./clusters.md": [
		8750,
		750
	],
	"./fa-roundup.md": [
		1072,
		72
	],
	"./goalie-evolution.md": [
		4852,
		852
	],
	"./privacy-policy.md": [
		7504,
		504
	],
	"./state-of-goalies.md": [
		2971,
		971
	],
	"./tos.md": [
		6087,
		87
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2639;
module.exports = webpackAsyncContext;